(function(){
'use strict';
var root = document.getElementById('aaRoot'); if(!root) return;
var ci = root.getAttribute('data-color-idx'); if(ci === null || ci === '' || ci === '-1') return;
var btns = [].slice.call(root.querySelectorAll('.aa-val[data-opt="' + ci + '"]'));
if(btns.length < 10) return;
var HEX = { 'white':'#f4f2ec','cream':'#efe6d0','black':'#1a1a1a','grey':'#8a8d91','gray':'#8a8d91','brown':'#6b4a33','chocolate brown':'#4b2e1f','light brown':'#a77b55','red':'#b3262e','dark red':'#8b1a1a','maroon':'#7a1f2b','pink':'#e86fa0','light pink':'#f4c2d0','yellow':'#f2d23c','orange':'#ee8a2f','dark orange':'#c4621a','green':'#2f7d3a','dark green':'#1f4d2e','light blue':'#8ec5ea','blue':'#2f5fa7','dark blue':'#1b2a5a','turquoise':'#28b5b0','purple':'#7a4fb0','beige':'#d8c3a5','navy':'#1b2a4a' };
var css = '.aa-cgrid{display:flex;flex-wrap:wrap;gap:9px;padding:2px 0 4px!important}'
+ '.aa-cdot{position:relative;flex:none!important;width:36px!important;min-width:36px!important;height:36px!important;padding:0!important;margin:0!important;border-radius:50%!important;background:var(--sw)!important;border:1px solid rgba(0,0,0,.28)!important;box-shadow:none!important;font-size:11px;font-weight:700;line-height:1;color:var(--tx);display:grid;place-items:center}'
+ '.aa-cdot.is-on{border:1px solid rgba(0,0,0,.28)!important;outline:2px solid #11233d;outline-offset:2px;background:var(--sw)!important}'
+ '.aa-cdot.is-off{opacity:.5}'
+ '.aa-cdot.is-off::after{left:7px!important;right:7px!important}'
+ '.aa-thumbs{display:none!important}';
var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
function lum(h){ var r = parseInt(h.substr(1,2),16), g = parseInt(h.substr(3,2),16), b = parseInt(h.substr(5,2),16); return (0.299*r + 0.587*g + 0.114*b) / 255; }
btns.forEach(function(b){
var v = b.getAttribute('data-value') || '';
var m = v.match(/\s(\d+)$/);
var base = v.replace(/\s+\d+$/, '').toLowerCase().trim();
var h = HEX[base] || '#bbbbbb';
b.setAttribute('data-label', v); b.setAttribute('title', v); b.setAttribute('aria-label', v);
b.style.setProperty('--sw', h); b.style.setProperty('--tx', lum(h) > 0.55 ? '#1d2024' : '#ffffff');
b.textContent = m ? m[1] : '';
b.classList.add('aa-cdot');
});
btns.forEach(function(b){ b.parentNode.classList.add('aa-cgrid'); });
var lbl = root.querySelector('[data-optval="' + ci + '"]');
var on = btns.filter(function(b){ return b.classList.contains('is-on'); })[0];
if(lbl && on) lbl.textContent = on.getAttribute('data-label');
})();
